module.exports = __webpack_public_path__ + "img/jm.064b6e88.svg";